import React from 'react';
import { CheckmarkCircleFilled24Icon } from '@royalaholddelhaize/design-system-pantry-web/assets/icons/ah';
import { Typography } from '@royalaholddelhaize/design-system-pantry-web/foundation/typography/typography';
import { createTestHook } from '../../utils/create-test-hook';
import css from './success-message.module.scss';

export interface SuccessMessageProps {
    text: string;
}

export const SuccessMessage: React.FC<SuccessMessageProps> = ({ text }) => (
    <Typography className={css.root} {...createTestHook('success-message')}>
        <CheckmarkCircleFilled24Icon size={16} className={css.icon} />
        <span>{text}</span>
    </Typography>
);
